import {
  CREATE_RATING,
  CREATE_RATING_FAILED,
  CREATE_RATING_REPLY,
  CREATE_RATING_REPLY_FAILED,
  CREATE_RATING_REPLY_SUCCESS,
  CREATE_RATING_SUCCESS,
  GET_RATINGS_BY_VENUE_OWNER_ID,
  GET_RATINGS_BY_VENUE_OWNER_ID_FAILED,
  GET_RATINGS_BY_VENUE_OWNER_ID_SUCCESS,
} from './constants';

export const getRatingsByVenueOwner = (userId) => ({
  type: GET_RATINGS_BY_VENUE_OWNER_ID,
  payload: { userId },
});

export const getRatingsByVenueOwnerSuccess = (ratings) => ({
  type: GET_RATINGS_BY_VENUE_OWNER_ID_SUCCESS,
  payload: { ratings },
});

export const getRatingsByVenueOwnerFailed = (error) => ({
  type: GET_RATINGS_BY_VENUE_OWNER_ID_FAILED,
  payload: { error },
});

export const createRating = (ratingData) => ({
  type: CREATE_RATING,
  payload: { rating: ratingData },
});

export const createRatingSuccess = (ratingData) => ({
  type: CREATE_RATING_SUCCESS,
  payload: { rating: ratingData },
});

export const createRatingFailed = (error) => ({
  type: CREATE_RATING_FAILED,
  payload: { error },
});

export const createRatingReply = (replyData) => ({
  type: CREATE_RATING_REPLY,
  payload: { reply: replyData },
});

export const createRatingReplySuccess = (reply) => ({
  type: CREATE_RATING_REPLY_SUCCESS,
  payload: { reply },
});

export const createRatingReplyFailed = (error) => ({
  type: CREATE_RATING_REPLY_FAILED,
  payload: { error },
});
